import { Button, Modal, Typography } from '@thingsw/pitta-design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { PAYMENT } from '../../features/Payment/slice';
import { RootState } from '../../features/store';

export interface SubscriptionExpiredModalProps {
  open: boolean;
  onLogout: () => void;
}

const SubscriptionExpiredModal = ({
  open,
  onLogout,
}: SubscriptionExpiredModalProps) => {
  const { t } = useTranslation();

  const { subscriptionInfo } = useSelector(
    (state: RootState) => state[PAYMENT]
  );
  return (
    <Modal
      open={open}
      onClose={onLogout}
      content={
        <>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginBottom: 16,
            }}
          >
            <Typography
              style={{
                marginBottom: 12,
              }}
              category='Default'
              variant='H6'
            >
              {t('Access Restricted:_')}
            </Typography>
            <Typography
              style={{
                marginBottom: 20,
              }}
              category='Default'
              variant='Body'
            >
              {t('Access is currently_')}
            </Typography>
            <Typography category='Default' variant='Body'>
              {t('Please contact your owner_')}
            </Typography>
            <Typography
              style={{
                marginBottom: 20,
              }}
              category='Default'
              variant='Body'
            >
              {t('Access will be_')}
            </Typography>
            <Typography category='Default' variant='Body'>
              {t('Owner')}: {subscriptionInfo?.masterEmail}
            </Typography>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'end',
            }}
          >
            <Button onClick={onLogout} color='primary'>
              {t('OK')}
            </Button>
          </div>
        </>
      }
    />
  );
};

export default SubscriptionExpiredModal;
